export default function NotFound(){
    return(
        <div className="container p-5 mt-5">
            <div className='row text-center'>
                <h1 className='mt-3 mb-2 fs-3 mb-4'>404 Page Not Found</h1>
                <p className='mb-5 fs-5'>Sorry, the page you are looking for does not exist</p>
            </div>
        </div>
    )
}